import script from "./NavBox.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBox.vue?vue&type=script&setup=true&lang=js"

import "./NavBox.vue?vue&type=style&index=0&id=b070fb82&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b070fb82"]])

export default __exports__